export default __webpack_public_path__ + "static/media/Location.543bee30.svg";